$(function(){
	$('.med_slider').slick({
		infinite: false, 
		prevArrow: '<button type="button" class="slick-prev"><svg class="arrow-svg"><use xlink:href="#arrow-right"></use></svg></button>', 
		nextArrow: '<button type="button" class="slick-next"><svg class="arrow-svg"><use xlink:href="#arrow-right"></use></svg></button>', 
		slidesToShow: 5, 
		responsive: [
		    {
			    breakpoint: 1024,
			    settings: {
			        slidesToShow: 4
			    }
		    }, 
		    {
			    breakpoint: 768,
			    settings: {
			        slidesToShow: 3
			    }
		    }, 
		    {
			    breakpoint: 600,
			    settings: {
			        slidesToShow: 2
			    }
		    }, 
		    {
			    breakpoint: 420,
			    settings: {
			        slidesToShow: 1
			    }
		    }
	    ]
	});

	$('.main_slider').slick({
	  	dots: true, 
	  	arrows: false, 
	  	infinite: true,
	  	speed: 500,
	  	fade: true,
	  	cssEase: 'linear'
	});

	$('.slider_gallery').slick({
		arrows: true, 
		variableWidth: true, 
		centerMode: true, 
		prevArrow: '<button type="button" class="slick-prev"><svg class="arrow-svg"><use xlink:href="#arrow-right"></use></svg></button>', 
		nextArrow: '<button type="button" class="slick-next"><svg class="arrow-svg"><use xlink:href="#arrow-right"></use></svg></button>'
	});
});

//Вкладки на странице сотрудника.
$(document).on('click', '.nav-tabs a', function (e) {
    e.preventDefault();
    var group = $(this).data('tab-group');
    var tab = $(this).data('tab');
    var container = $(this).parents('.nav-tabs');
    $(container).find('a.active').removeClass('active');
    $(this).addClass('active');
    $('#' + group).find('.tab-info').addClass('hide');
    $('#' + tab).removeClass('hide');
});

$(document).on('click', '#move_up', function () {
    $('body,html').animate({
        scrollTop: 0
    }, 800);
    return false;
});
$(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
        $('#move_up').addClass('show');
    } else {
        $('#move_up').removeClass('show');
    }
});